import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL  

class LogsApi {
    getLogsByServiceName(serviceName, config) {
        return axios.get(`${BASE_URL}/logs/service/${serviceName}`, config)
    }
}

export default new LogsApi()

